module.exports = __webpack_public_path__ + "static/media/WhatsApp Image 2021-09-20 at 3.26.14 PM.3cdb8ec3.jpeg";